import React from "react";
import { Layout } from "antd";
import VerifyModal from "../../Components/Auth/VerifyModal/VerifyModal";
import { LanguageSwitcher } from "../../Components/LanguageSwitcher/LanguageSwitcher";
import { ThemeSwitcher } from "../../Components/ThemeSwitcher/ThemeSwitcher";
import { PageHeading } from "./PageHeading";
import { UserMenu } from "./UserMenu";

const { Header: AntHeader } = Layout;

export const Header: React.FC = () => (
  <AntHeader className="header" style={{ background: "transparent" }}>
    <div style={{ minWidth: 0, flex: "1 1 auto" }}>
      <PageHeading />
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
      <ThemeSwitcher />
      <LanguageSwitcher />
      <UserMenu />
      <VerifyModal />
    </div>
  </AntHeader>
);
